import { render, staticRenderFns } from "./menu-grid.vue?vue&type=template&id=3085dde8&"
import script from "./menu-grid.vue?vue&type=script&lang=js&"
export * from "./menu-grid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports